const state = () => ({
  logResultados: {}
});

const getters = {
  getLog: state => {
    return state.logResultados;
  }
};

const mutations = {
  SET_LOG(state, log) {
    state.logResultados = { ...state.logResultados, ...log };
  },
  LIMPA_LOG(state) {
    state.logResultados = {};
  }
};

const actions = {
  setLog({ commit }, log) {
    commit("SET_LOG", log);
  },
  setLimpaLog({ commit }) {
    commit("LIMPA_LOG");
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
